import styles from "./AppWeekday.module.scss";

import { type ThHTMLAttributes } from "react";

export function AppWeekday(props: ThHTMLAttributes<HTMLTableCellElement>) {
  const { style, className, ...rest } = props;

  return <th className={`${className} ${styles.weekday}`} {...rest} />;
}
